<template>
  <div class="answer" :class="{ active: selected }">
    <input :id="answer.id" :checked="selected" name="answers" type="radio" @click="handleClick" />
    <label :for="answer.id">
      {{ answer.name }}
    </label>
  </div>
</template>

<script>
export default {
  name: 'SurveyAnswerListItem',
  props: {
    answer: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      selected: this.answer.selected
    }
  },
  methods: {
    handleClick() {
      this.$emit('select', this.answer.id)
    }
  }
}
</script>

<style scoped>
.answer label {
  position: relative;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  color: rgba(0, 0, 0, 0.87);
  font-size: 1rem;
  line-height: 1;
  padding: 1rem;
  margin: 0.5rem 0 0;
  background-color: rgba(0, 0, 0, 0.03);
  border: 1px solid rgba(0, 0, 0, 0.03);
  border-radius: 3px;
  outline: none;
  cursor: pointer;
  transition: color 180ms ease, border-color 180ms ease, background-color 180ms ease;
}

.answer input[type='radio'] {
  display: none;
}

.answer label::before {
  flex-shrink: 0;
  display: block;
  content: '';
  width: 1.188rem;
  height: 1.188rem;
  background-color: #fff;
  margin-right: 0.5rem;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 50%;
  transition: border-color 180ms ease, background-color 180ms ease, box-shadow 180ms ease;
}

.answer:hover label {
  color: rgba(0, 0, 0, 0.94);
  background-color: rgba(0, 0, 0, 0.08);
  border-color: rgba(0, 0, 0, 0.08);
}

.answer:hover label:before {
  background-color: rgba(0, 0, 0, 0.12);
  border-color: transparent;
  box-shadow: inset 0 0 0 0.125rem rgba(255, 255, 255, 1);
}

.answer.active label {
  background-color: rgb(53, 152, 219, 0.12);
  border-color: rgb(53, 152, 219, 0.64);
}

.answer.active label:before {
  background-color: #3598db;
  border-color: transparent;
  box-shadow: inset 0 0 0 0.125rem rgba(255, 255, 255, 1);
}
</style>
